import type { Locale } from "common/models";
import { settingsRepository } from "data-access/repository/settings/SettingsRepository";

export const settingsApi = {
    getLocale: (): Promise<Locale | undefined> => settingsRepository.getLocale(),

    removeSettings: (): Promise<void> => settingsRepository.removeSettings(),

    getLastActivityDate: (): Promise<Date | undefined> => settingsRepository.getLastActivityDate(),

    setLastActivityDate: (): Promise<void> => settingsRepository.setLastActivityDate(),
};
